import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  BANKACCOUNT_LIST,
  BANKACCOUNT_CREATE,
  BANKACCOUNT_UPDATE,
  BANKACCOUNT_DELETE,
  M_POST,
  BANK_NAME_LIST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'bankaccount' })
export default class Bankaccount extends VuexModule {
  bankaccountList: any = [];

  bankNameList: any = [];

  @Mutation
  mutateBankNameList(data) {
    this.bankNameList = data;
  }

  @Action({ commit: 'mutateBankNameList' })
  FetchBankName(params = {}) {
    return Vue.axios({
      url: BASE_URL + BANK_NAME_LIST,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateBankaccount(bankaccount) {
    this.bankaccountList = bankaccount;
  }

  @Action({ commit: 'mutateBankaccount' })
  FetchBankAccount(params = {}) {
    return Vue.axios({
      url: BASE_URL + BANKACCOUNT_LIST,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  CreateBankAccount(params) {
    return Vue.axios({
      url: BASE_URL + BANKACCOUNT_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateBankAccount(params) {
    return Vue.axios({
      url: BASE_URL + BANKACCOUNT_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  DeleteBankAccount(params) {
    return Vue.axios({
      url: BASE_URL + BANKACCOUNT_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
